"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.AgnosticEmailForm = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
// TODO: create a CMS-agnostic, non-contentstack driven form

var AgnosticEmailForm = function AgnosticEmailForm() {
  return /*#__PURE__*/_react.default.createElement("p", null, "Hi, I'm a non-contentstack-driven form");
};
exports.AgnosticEmailForm = AgnosticEmailForm;
var _default = AgnosticEmailForm;
exports.default = _default;